import TravianVersion from "../enum/version";
import {merge} from "../../helper/arrayHelper";
import {
    TravianKingdomsFeatureSet,
    TravianLegendsFeatureSet,
    TravianVersionWithFeatures,
    TravianVersionWithPartialFeatures
} from "../Version";
import Tribe from "../enum/Tribe";

const defaultLegendsFeatures: TravianLegendsFeatureSet = {
    speed: 1,
    troopSpeed: 1,
    tribeBalancing: {
        roman2023: false,
        teuton2024: false,
        gaul2024: false,
        romanAS2024: false,
    },
    // Let's take International server as default for tribes.
    enabledPlayableTribes: [Tribe.Roman, Tribe.Teuton, Tribe.Gaul, Tribe.Egypt, Tribe.Hun],
    reducedInfrastructureConstructionTimes: false,
    increasedResourceProduction: true,
}

const defaultKingdomsFeatures: TravianKingdomsFeatureSet = {
    speed: 1,
    troopSpeed: 1,
}

export function fillPartialFeaturesWithDefaults(partial: TravianVersionWithPartialFeatures): TravianVersionWithFeatures {
    const base: TravianVersionWithFeatures = partial.version === TravianVersion.Legends ? {
        version: TravianVersion.Legends,
        features: defaultLegendsFeatures,
    } : {
        version: TravianVersion.Kingdoms,
        features: defaultKingdomsFeatures,
    };

    return merge<TravianVersionWithFeatures>(base, partial);
}
